import React from 'react';

import { graphql, Link, useStaticQuery } from 'gatsby';
import { Activity } from 'lucide-react';

import { searchIndices } from '../../../../lib/queries/algolia.queries';
import { useAllContent } from '../../../../hooks/use-all-content';
import { getSearchResult } from '../../../../lib/helpers/search.helpers';
import FilteredSearchResult from './filtered-search-result';

type SearchResultProps = {
  searchQuery: string;
}
const SearchResult = ({searchQuery}: SearchResultProps) => {
  const data = useAllContent()
  const { posts, howtos, snippets, fridays} = data;
  const filteredPosts = getSearchResult(posts, searchQuery);
  const filteredHowtos = getSearchResult(howtos, searchQuery);
  const filteredSnippets = getSearchResult(snippets, searchQuery);
  const filteredFridays = getSearchResult(fridays, searchQuery);

  return (
    <div className='space-y-4 px-2 py-4'>
      <div>
        <ul>
        <FilteredSearchResult filteredPosts={filteredPosts} filteredHowtos={filteredHowtos} filteredSnippets={filteredSnippets} filteredFridays={filteredFridays} />
        </ul>
      </div>
    </div>
  );
};
export default SearchResult;
